import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2160a90e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "wrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_voice_to_text = _resolveComponent("app-voice-to-text")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_app_header, { class: "header" }, {
            "top-left": _withCtx(() => [
              _createVNode(_component_router_link, {
                to: "/settings",
                class: "back-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            "top-middle": _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$localize('settings.journey.title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_app_input, {
              name: "journey",
              modelValue: _ctx.journeyName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.journeyName) = $event)),
              label: _ctx.$localize('settings.journey.label'),
              placeholder: _ctx.$localize('settings.journey.placeholder')
            }, null, 8, ["modelValue", "label", "placeholder"]),
            _createVNode(_component_app_button, {
              onClick: _ctx.submitJourney,
              type: "primary",
              class: "w-100 el-button-lg",
              round: "",
              disabled: !_ctx.journeyName?.length
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('app.settings.journey.submit')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_app_voice_to_text)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_app_header, { class: "header" }, {
            "top-left": _withCtx(() => [
              _createVNode(_component_router_link, {
                to: "/settings",
                class: "back-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            "top-middle": _withCtx(() => [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$localize('settings.journey.title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_app_button, {
              type: "primary",
              class: "w-100 el-button-lg",
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('app.settings.journey.submit')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]))
}